var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9182_205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9182_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87533 14.9999C5.43088 14.9999 4.20171 14.493 3.18783 13.4791C2.17394 12.4652 1.66699 11.236 1.66699 9.79159C1.66699 8.34714 2.17394 7.11797 3.18783 6.10409C4.20171 5.0902 5.43088 4.58325 6.87533 4.58325H14.5837C15.6253 4.58325 16.5107 4.94784 17.2399 5.677C17.9691 6.40617 18.3337 7.29159 18.3337 8.33325C18.3337 9.37492 17.9691 10.2603 17.2399 10.9895C16.5107 11.7187 15.6253 12.0833 14.5837 12.0833H7.29199C6.6531 12.0833 6.11144 11.861 5.66699 11.4166C5.22255 10.9721 5.00033 10.4305 5.00033 9.79159C5.00033 9.1527 5.22255 8.61103 5.66699 8.16659C6.11144 7.72214 6.6531 7.49992 7.29199 7.49992H14.167C14.4031 7.49992 14.601 7.57978 14.7607 7.7395C14.9205 7.89922 15.0003 8.09714 15.0003 8.33325C15.0003 8.56936 14.9205 8.76728 14.7607 8.927C14.601 9.08672 14.4031 9.16659 14.167 9.16659H7.29199C7.11144 9.16659 6.96213 9.22561 6.84408 9.34367C6.72602 9.46172 6.66699 9.61103 6.66699 9.79159C6.66699 9.97214 6.72602 10.1214 6.84408 10.2395C6.96213 10.3576 7.11144 10.4166 7.29199 10.4166H14.5837C15.167 10.4027 15.66 10.1978 16.0628 9.802C16.4656 9.40617 16.667 8.91659 16.667 8.33325C16.667 7.74992 16.4656 7.25686 16.0628 6.85409C15.66 6.45131 15.167 6.24992 14.5837 6.24992H6.87533C5.88921 6.23603 5.05241 6.57631 4.36491 7.27075C3.67741 7.9652 3.33366 8.80547 3.33366 9.79159C3.33366 10.7638 3.67741 11.5902 4.36491 12.2708C5.05241 12.9513 5.88921 13.3055 6.87533 13.3333H14.167C14.4031 13.3333 14.601 13.4131 14.7607 13.5728C14.9205 13.7326 15.0003 13.9305 15.0003 14.1666C15.0003 14.4027 14.9205 14.6006 14.7607 14.7603C14.601 14.9201 14.4031 14.9999 14.167 14.9999H6.87533Z",
    fill: "#996CFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f3ab2b0eb3e3c582aeabec2c2675a8da.svg";
export { ForwardRef as ReactComponent };